<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true,
    }
  },
  mounted() {
    // 检测浏览器路由改变页面不刷新问题,hash模式的工作原理是hashchange事件
    // window.addEventListener('hashchange', () => {
    //   let currentPath = window.location.hash.slice(1)
    //   if (this.$route.path !== currentPath) {
    //     this.$router.push(currentPath)
    //   }
    // }, false)
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true
      });
    }
  }
}
</script>

<style>
body {
  margin: 0;
  overflow: hidden;
}

.el-tooltip__popper {

  max-width: 800px;

}

#app {
  min-width: 1200px;
  margin: 0 auto;
  /* font-family: 'Microsoft YaHei',"Helvetica Neue", "PingFang SC", 'Arial', 'sans-serif'; */
  /* -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none; */
  /* user-select: none; //禁选*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue